import { FC } from 'react';
import { Sync as SyncIcon } from '@mui/icons-material';
import IconDocument from 'src/assets/images/icons/document.svg';
import TransportMediumIcon from '../card/TransportMediumIcon';

interface DocumentIconWithModalitiesProps {
  modalities?: string[];
  isProcessing: boolean;
  invoiceFileProcessingId?: string;
}

/**
 * Shared component to render document icon with transport modalities badges
 * Used by both notification and upload UploadStatusItem components
 */
export const DocumentIconWithModalities: FC<DocumentIconWithModalitiesProps> = ({ modalities, isProcessing, invoiceFileProcessingId }) => {
  return (
    <div className='w-36 relative'>
      <img src={IconDocument} alt='' />
      <span className='absolute -right-2 -bottom-2'>
        {!modalities ? (
          <>
            {isProcessing && (
              <div className='rounded-full border border-[#597282] bg-[#EBEEF0] flex items-center justify-center'>
                <SyncIcon className='text-[#597282] animate-spin-reverse' sx={{ fontSize: '16px' }} />
              </div>
            )}
          </>
        ) : (
          <>
            {modalities && modalities.length > 0 && (
              <div className='absolute -right-2 -bottom-2 flex flex-wrap gap-1'>
                {modalities.slice(0, 3).map((modality) => (
                  <TransportMediumIcon key={`${modality}-${invoiceFileProcessingId}`} medium={modality as any} iconColor='#9F9F9F' size='sm' />
                ))}
                {modalities.length > 3 && (
                  <div className='w-16 h-16 rounded-full bg-gray-200 flex items-center justify-center text-xs text-gray-600'>+{modalities.length - 3}</div>
                )}
              </div>
            )}
          </>
        )}
      </span>
    </div>
  );
};
